/*
 * File: CollapseHandler.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles collapse state of a MUI Collapse components
 */

import React, { useState } from "react";

export default props => {
  let [expanded, setExpanded] = useState(false);
  let onToggle = () => setExpanded(!expanded);
  return React.cloneElement(props.children, { expanded, onToggle });
};
